import React, {useState} from 'react';
import PageHeader from "../../common/PageHeader";
import {useBreadcrumbComponent} from "../../common/useBreadcrumbComponent";
import Tabs from "../../common/Tabs";
import Tab from "../../common/Tab";
import ActivityReportSummarySaved from "./ActivityReportSummarySaved";
import ActivityReportSummaryScheduled from "./ActivityReportSummaryScheduled";
import {AutoAwesomeRounded, SaveRounded, ScheduleRounded, ScheduleSendRounded} from "@mui/icons-material";
import Button from "../../common/Button";
import StartAIReportGeneratorDialog from "./StartAIReportGeneratorDialog";
import ScheduleReportDialog from "./ScheduleReportDialog";

const ActivityReportSummaryManager = () => {
    const BreadcrumbBar = useBreadcrumbComponent({ dropLast: true });

    const TABS = {
        SAVED: { val: 0 },
        SCHEDULED: { val: 1 }
    };

    const [activeTabKey, setActiveTabKey] = useState(TABS.SAVED.val);
    const [isAIReportGeneratorDialogVisible, setAIReportGeneratorDialogVisible] = useState(false);
    const [isScheduleReportDialogVisible, setScheduleReportDialogVisible] = useState(false);
    const [scheduledRefetchTrigger, setScheduledRefetchTrigger] = useState(0);

    const handleChangeTab = (key) => {
        setActiveTabKey(key);
    };

    const handleAIReportGeneratorClick = () => {
        setAIReportGeneratorDialogVisible(true);
    };

    const handleScheduleReportClick = () => {
        setScheduleReportDialogVisible(true);
    };

    const handleDialogClose = () => {
        setAIReportGeneratorDialogVisible(false);
    };

    const handleScheduleDialogClose = () => {
        setScheduleReportDialogVisible(false);
    };

    const handleScheduleSuccess = () => {
        setActiveTabKey(TABS.SCHEDULED.val);
        setScheduledRefetchTrigger(prev => prev + 1);
    };

    return (
        <div className={'ch-summary-manager'}>
            <BreadcrumbBar />
            <PageHeader
                title={'Activity Summaries'}
                subtitle={'Automatically generate summary comments for reports based on activities completed by your students.'}
                buttons={
                <>
                    <Button
                        type={'outline'}
                        onClick={handleScheduleReportClick}
                        icon={<ScheduleSendRounded />}
                    >
                        New Schedule
                    </Button>
                    <Button
                        onClick={handleAIReportGeneratorClick}
                        icon={<AutoAwesomeRounded />}
                    >
                        New Summary
                    </Button>
                </>
                }
            />
            <Tabs overrideKey={activeTabKey} variant="standard" onChange={handleChangeTab} contentClassName="margin-t--l" destroyInactiveTabPane={true}>
                <Tab tab={
                    <>
                        <SaveRounded className={'margin-r--m'} />
                        <span className={'margin-r--m tabText'}>Saved</span>
                    </>
                } key={TABS.SAVED.val}>
                    <ActivityReportSummarySaved />
                </Tab>
                <Tab tab={
                    <>
                        <ScheduleRounded className={'margin-r--m'} />
                        <span className={'margin-r--m tabText'}>Scheduled</span>
                    </>
                } key={TABS.SCHEDULED.val}>
                    <ActivityReportSummaryScheduled refetchTrigger={scheduledRefetchTrigger} />
                </Tab>
            </Tabs>
            <StartAIReportGeneratorDialog
                visible={isAIReportGeneratorDialogVisible}
                handleClose={handleDialogClose}
            />
            <ScheduleReportDialog
                visible={isScheduleReportDialogVisible}
                handleClose={handleScheduleDialogClose}
                onScheduleSuccess={handleScheduleSuccess}
            />
        </div>
    );
};

export default ActivityReportSummaryManager;